const keepStatus = {
	state:{
		curIndex:'',
		flag:false
	},
	mutations:{
		SET_CURINDEX:(state, index) => {
			state.curIndex = index;
		},
		SET_FLAG:(state, flag) => {
			state.flag = flag;
		},
	},
	actions:{
		setCurIndex({commit},index){
			commit('SET_CURINDEX',index)
		},
		setFlag({commit},flag){
			commit('SET_FLAG',flag)
		},
	}
}
export default keepStatus;


// WEBPACK FOOTER //
// ./src/store/modules/keepStatus.js